// extracted by mini-css-extract-plugin
export default {"shareContent":"ViewContent_shareContent__h64Po","imageSection":"ViewContent_imageSection__XTy4+"};